const Config = {
	MODE: import.meta.env.MODE ?? "",
	PROD: import.meta.env.PROD,
	DEV: import.meta.env.DEV,
	AUTO_UPDATER_FEED_BASE_URL:
		import.meta.env.VITE_AUTO_UPDATER_FEED_BASE_URL ?? "",
	// metadata -- start
	BUILDIDENTIFIER: import.meta.env.APP_BUILDIDENTIFIER ?? "",
	NAME: import.meta.env.VITE_NAME ?? "",
	PRODUCTNAME: import.meta.env.APP_PRODUCTNAME ?? "",
	DESCRIPTION: import.meta.env.APP_DESCRIPTION ?? "",
	AUTHORS: import.meta.env.APP_AUTHORS ?? "",
	ICONFILENAMEPREFIX: import.meta.env.APP_ICONFILENAMEPREFIX ?? "",
	ENV: import.meta.env.APP_ENV ?? "",
	VERSION: import.meta.env.APP_VERSION ?? "",
	// metadata -- end
	AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL ?? "",
	API: import.meta.env.VITE_API ?? "",
	BW_API: import.meta.env.VITE_BW_API ?? "",
};

export { Config };
